module.exports = __webpack_public_path__ + "static/media/reparo-em-andamento.1c7d91e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/reparo-em-andamento.svg
// module id = 2785
// module chunks = 0